// Always use relative URL - works in all environments
export const getApiUrl = () => '/api';

export const API = '/api';
